import { Icon } from '@printos/agnostic-icon';

function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".pros-dialog-position{display:flex;flex-direction:column;justify-content:flex-start;align-items:center;min-height:0;flex:1;box-sizing:border-box}.pros-dialog-position .pros-dialog-page{display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;box-sizing:border-box;border-radius:16px;border:1px solid #fff;box-shadow:0 8px 20px rgba(33,33,33,.2);max-width:100%;max-height:90%}.pros-dialog-position .pros-dialog-page .pros-dialog-scroll{box-sizing:border-box;width:100%;overflow:auto;padding:32px}.pros-dialog-position .pros-dialog-page .pros-dialog-footer{display:flex;justify-content:flex-start;align-items:center;box-sizing:border-box;border-top:1px solid #f3f3f3;padding:8px 32px;width:100%;flex-shrink:0}.pros-dialog-position .pros-dialog-page .pros-dialog-footer else{flex-direction:row}.pros-dialog-outer{flex:1;max-height:100%;width:100%;box-sizing:border-box}.pros-dialog-outer.start{justify-content:flex-start}.pros-dialog-outer.center,.pros-dialog-outer.start{display:flex;flex-direction:column;align-items:center}.pros-dialog-outer.center{justify-content:center;height:100%}.pros-dialog-outer .pros-dialog-inner{display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;border-radius:16px;border:1px solid #fff;box-shadow:0 8px 20px rgba(33,33,33,.2);box-sizing:border-box;max-width:100%;max-height:100%;padding:32px}.pros-dialog-outer .pros-dialog-inner .pros-error-message{width:100%;background-color:#ff5722;color:#fff;padding:8px}.pros-dialog-outer .pros-dialog-inner .pros-dialog-header{display:flex;justify-content:flex-start;align-items:center;box-sizing:border-box;width:100%;flex-shrink:0;padding-bottom:20px}.pros-dialog-outer .pros-dialog-inner .pros-dialog-header else{flex-direction:row}.pros-dialog-outer .pros-dialog-inner .pros-dialog-header .pros-dialog-title{flex:1;margin:0;font-size:32px;line-height:36px;font-weight:400}.pros-dialog-outer .pros-dialog-inner .pros-dialog{display:flex;flex-direction:column;justify-content:flex-start;align-items:center;box-sizing:border-box;flex:1;max-width:100%;min-height:0}.pros-dialog-outer .pros-dialog-inner .pros-dialog-content{display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;box-sizing:border-box;flex:1;overflow:auto;width:100%;font-size:16px;line-height:24px}.pros-dialog-outer .pros-dialog-inner .pros-dialog-content .pros-description{font-weight:400}.pros-dialog-outer .pros-dialog-inner .pros-dialog-footer{display:flex;justify-content:flex-end;align-items:center;box-sizing:border-box;padding-top:32px;width:100%;flex-shrink:0}.pros-dialog-outer .pros-dialog-inner .pros-dialog-footer else{flex-direction:row}.pros-progress-overlay{position:absolute;top:0;right:0;bottom:0;left:0;border-radius:4px;background-color:#fff;padding:32px;box-sizing:border-box;display:flex;justify-content:center;align-items:center;flex:1}.pros-progress-overlay else{flex-direction:row}.pros-progress-overlay .progress-container{display:flex;flex-direction:column;justify-content:flex-start;align-items:center}.pros-progress-overlay .progress-container .title{display:flex;justify-content:center;align-items:center;font-weight:700;padding:4px;text-align:center}.pros-progress-overlay .progress-container .title else{flex-direction:row}.pros-progress-overlay .progress-container .details{display:flex;justify-content:center;align-items:center;padding:4px;text-align:center}.pros-progress-overlay .progress-container .details else{flex-direction:row}.pros-progress-overlay .progress-container .spinner{display:flex;justify-content:center;align-items:center;padding:4px}.pros-progress-overlay .progress-container .spinner else{flex-direction:row}body[pos--theme=light] .pros-dialog-inner,body[pos--theme=light] .pros-dialog-page{color:#212121;background-color:#fff;border-color:#fff}body[pos--theme=dark] .pros-dialog-inner,body[pos--theme=dark] .pros-dialog-page{color:#fff;background-color:#2b2b2b;border-color:#2b2b2b}.pros-dialog-outer[pos--theme=light] .pros-dialog-inner,.pros-dialog-outer[pos--theme=light] .pros-dialog-page{color:#212121;background-color:#fff;border-color:#fff}.pros-dialog-outer[pos--theme=dark] .pros-dialog-inner,.pros-dialog-outer[pos--theme=dark] .pros-dialog-page{color:#fff;background-color:#2b2b2b;border-color:#2b2b2b}printos-backdrop{z-index:1000;opacity:.48;background-color:#212121}printos-backdrop,printos-dialog{position:fixed;top:0;bottom:0;left:0;right:0}printos-dialog{box-sizing:border-box;z-index:1001}";
styleInject(css_248z);

// Deferred helper
// From https://developer.mozilla.org/en-US/docs/Mozilla/JavaScript_code_modules/Promise.jsm/Deferred#backwards_forwards_compatible
function Deferred() {
  // update 062115 for typeof
  if (typeof Promise !== 'undefined' && Promise.defer) {
    //need import of Promise.jsm for example: Cu.import('resource:/gree/modules/Promise.jsm');
    return Promise.defer();
  } else if (typeof PromiseUtils !== 'undefined' && PromiseUtils.defer) {
    //need import of PromiseUtils.jsm for example: Cu.import('resource:/gree/modules/PromiseUtils.jsm');
    return PromiseUtils.defer();
  } else {
    /* A method to resolve the associated Promise with the value passed.
     * If the promise is already settled it does nothing.
     *
     * @param {anything} value : This value is used to resolve the promise
     * If the value is a Promise then the associated promise assumes the state
     * of Promise passed as value.
     */
    this.resolve = null;

    /* A method to reject the assocaited Promise with the value passed.
     * If the promise is already settled it does nothing.
     *
     * @param {anything} reason: The reason for the rejection of the Promise.
     * Generally its an Error object. If however a Promise is passed, then the Promise
     * itself will be the reason for rejection no matter the state of the Promise.
     */
    this.reject = null;

    /* A newly created Promise object.
     * Initially in pending state.
     */
    this.promise = new Promise(function (resolve, reject) {
      this.resolve = resolve;
      this.reject = reject;
    }.bind(this));
    Object.freeze(this);
  }
}

var DEFAULT_OPTIONS = {
  clickOutsideToClose: false,
  escapeToClose: true
};
var Dialog = /*#__PURE__*/function () {
  function Dialog() {
    _classCallCheck(this, Dialog);
  }
  return _createClass(Dialog, [{
    key: "show",
    value: function show(options) {
      var opts = _objectSpread2(_objectSpread2({}, DEFAULT_OPTIONS), options);
      this._prependBackdropToBody();
      this._appendDialogToBody(opts);

      // TODO: disallow showing multiple dialogs
      // Instead of using static data, consider adding a namespaced global variable.
      Dialog._showing = new Deferred();
      return Dialog._showing.promise;
    }
  }, {
    key: "hide",
    value: function hide(response) {
      Dialog._showing.resolve(response);
      Dialog._close();
      return Promise.resolve();
    }
  }, {
    key: "cancel",
    value: function cancel(response) {
      Dialog._showing.reject(response);
      Dialog._close();
      return Promise.resolve();
    }
  }, {
    key: "_prependBackdropToBody",
    value: function _prependBackdropToBody() {
      var backdrop = document.createElement('printos-backdrop');
      backdrop.id = 'printos-backdrop';
      document.body.prepend(backdrop);
    }
  }, {
    key: "_appendDialogToBody",
    value: function _appendDialogToBody(opts) {
      var _this = this;
      var _theme = opts.options && opts.options.theme ? opts.options.theme : 'auto';
      var dialogContent = document.createElement('div');
      dialogContent.classList.add('pros-dialog-inner');
      var dialogContainer = document.createElement('div');
      dialogContainer.classList.add('pros-dialog-outer');
      dialogContainer.classList.add('center');
      dialogContainer.setAttribute('pos--theme', _theme);
      dialogContainer.append(dialogContent);
      if (opts.title) {
        var titleBar = this._createTitleBar(opts);
        dialogContent.append(titleBar);
      }
      dialogContent.append(opts.content);
      var dialog = document.createElement('printos-dialog');
      dialog.id = 'printos-dialog';
      dialog.append(dialogContainer);
      if (opts.clickOutsideToClose) {
        dialog.addEventListener('click', function (event) {
          _this.cancel(event);
        });
      }
      if (opts.escapeToClose) {
        dialog.setAttribute('tabIndex', '-1');
        dialog.addEventListener('keydown', function (event) {
          if (event.key === 'Escape') {
            event.stopPropagation();
            event.preventDefault();
          }
        });
        dialog.addEventListener('keyup', function (event) {
          if (event.key === 'Escape') {
            event.stopPropagation();
            event.preventDefault();
            _this.cancel(event);
          }
        });
      }
      document.body.append(dialog);
      dialog.focus();
    }
  }, {
    key: "_createTitleBar",
    value: function _createTitleBar(opts) {
      var _this2 = this;
      var titleBar = document.createElement('div');
      titleBar.classList.add('pros-dialog-header');
      var title = document.createElement('h2');
      title.classList.add('pros-dialog-title');
      title.textContent = opts.title;
      var closeBtn = document.createElement('div');
      closeBtn.classList.add('pros-btn-close');
      closeBtn.addEventListener('click', function (event) {
        _this2.cancel(event);
      });
      new Icon({
        target: closeBtn,
        props: {
          path: 'general/veneer/x-o',
          theme: opts.options && opts.options.theme ? opts.options.theme : 'auto',
          mode: 'clickable'
        }
      });
      titleBar.append(title, closeBtn);
      return titleBar;
    }
  }], [{
    key: "_close",
    value: function _close() {
      var backdrop = document.getElementById('printos-backdrop');
      if (backdrop) {
        backdrop.remove();
      }
      var dialog = document.getElementById('printos-dialog');
      if (dialog) {
        dialog.remove();
      }
    }
  }]);
}();

var dialog = new Dialog();

export { Dialog, dialog };
